define("shared/utils/analytics/timezone-helpers/shift-time-to-end-of-local-day", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class shiftTimeToEndOfLocalDay
   * @extends Utils
   */

  /**
   * Shifts a data point's time value to the end of the local day
   *
   * @method shiftTimeToEndOfLocalDay
   * @param {Number} time Unix time for any given data point
   *
   * @return {Number} Unix time shifted to end of local day, in ms.
   */
  const shiftTimeToEndOfLocalDay = (time, timeZoneIdentifier) => moment(time * 1000).tz(timeZoneIdentifier).endOf('day').valueOf();

  var _default = shiftTimeToEndOfLocalDay;
  _exports.default = _default;
});